interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}

export function Card({ children, className = "", padding = true }: CardProps) {
  return (
    <div className={`camp-card ${padding ? "p-5" : ""} ${className}`}>
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function CardHeader({ title, subtitle, actions }: CardHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4 mb-4">
      <div>
        <h3 className="text-base font-semibold text-stone-900">{title}</h3>
        {subtitle && <p className="text-sm text-stone-500 mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}

interface StatCardProps {
  label: string;
  value: string | number;
  subValue?: React.ReactNode;
  icon?: React.ReactNode;
  color?: "green" | "amber" | "bark" | "stone";
}

const colorMap = {
  green: "text-forest-600 bg-forest-50",
  amber: "text-amber-600 bg-amber-50",
  bark: "text-bark-600 bg-bark-50",
  stone: "text-stone-600 bg-stone-100",
};

export function StatCard({ label, value, subValue, icon, color = "green" }: StatCardProps) {
  return (
    <div className="camp-card p-5">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-stone-500 font-medium">{label}</p>
          <p className="text-3xl font-bold text-stone-900 mt-1 leading-none">{value}</p>
          {subValue && <div className="text-xs text-stone-400 mt-1 space-y-0.5">{subValue}</div>}
        </div>
        {icon && (
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${colorMap[color]}`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
